var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.estilo,attrs:{"href":_vm.destino,"disabled":_vm.desabilitado}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.texto))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }